import React from "react";

export function CardRadioField({
  item,
  value,
  error,
  disabled,
  onValueChange,
}) {
  const orientation = item?.orientation || "horizontal";

  return (
    <div
      className={`
        grid gap-4
        ${orientation === "horizontal" ? "grid-cols-2" : "grid-cols-1"}
        w-full
      `}
    >
      {item.options?.map((option) => {
        const isSelected = value === option.value;

        return (
          <div
            key={option.value}
            onClick={() => !disabled && onValueChange(option.value)}
            className={`
              flex flex-col items-center justify-center p-6 rounded-lg border cursor-pointer transition
              ${isSelected ? "border-primary-3 bg-primary-7" : "border-neutral-5 bg-neutral-1"}
              ${disabled ? "opacity-50 cursor-not-allowed" : ""}
            `}
          >
            {/* Icon */}
            <div
              className={`mb-2 ${
                isSelected ? "text-primary-3" : "text-[#262626]"
              }`}
            >
              {option.icon}
            </div>

            {/* Label */}
            <span className="text-sm text-[#262626] text-center">
              {option.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
